export { FlightsMetaFIStoFSR } from './Flights_meta_ow_fis_to_fsr_46906';

export const EXPERIMENT_NAME = 'Flights_META_OW_FIS_to_FSR';
